import { render, staticRenderFns } from "./nav-flyout.vue?vue&type=template&id=c6570378&scoped=true&"
import script from "./nav-flyout.vue?vue&type=script&lang=js&"
export * from "./nav-flyout.vue?vue&type=script&lang=js&"
import style0 from "./nav-flyout.vue?vue&type=style&index=0&id=c6570378&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6570378",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6570378')) {
      api.createRecord('c6570378', component.options)
    } else {
      api.reload('c6570378', component.options)
    }
    module.hot.accept("./nav-flyout.vue?vue&type=template&id=c6570378&scoped=true&", function () {
      api.rerender('c6570378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/nav-flyout.vue"
export default component.exports